const PostTitle = ({ title }) => {
  return (
    <div className="bg-white">
      <div className="max-w-7xl py-8 ">
        <div className="sm:text-center lg:text-left">
          <h1 className="font-headline mt-1 text-3xl font-semibold text-gray-900 sm:text-4xl lg:text-5xl">
            {title}
          </h1>
        </div>
      </div>
    </div>
  );
};

export default PostTitle;
